import { decorate, observable, action } from 'mobx';
import * as Api from '../lib/api';

export class DiscountStore {
    loading = false;
    toggleLoading = false;
    discount = null;
    userLevelInfo = null;
    levels = [];

    regionOfferLoading = false;
    regionOffers = [];

    getDiscounts = () => {
        this.loading = true;

        Api.fetch('bonus/shares')
            .then(response => {
                if (response.success) {
                    this.discount = response?.result?.discount;
                    this.userLevelInfo = response?.result?.my_bonus;
                    this.levels = response?.result?.my_bonus.levels;
                }
            })
            .finally(() => {
                this.loading = false;
            });
    };

    getRegionOffers = () => {
        this.regionOfferLoading = true;

        Api.fetch('bonus/shares-region')
            .then(response => {
                if (response.success) {
                    this.regionOffers = response?.result;
                }
            })
            .finally(() => {
                this.regionOfferLoading = false;
            });
    };

    toggleFavorite = (id, action) => {
        this.toggleLoading = true;

        if (action === 'remove') {
            Api.fetch('user/favorites', { product_id: id }, 'DELETE')
                .then(response => {
                    if (response.success) {
                        const productIndex = this.regionOffers.findIndex(product => product.id === id);
                        this.regionOffers[productIndex] = { ...this.regionOffers[productIndex], isFavorite: false };
                    }
                })
                .finally(() => {
                    this.toggleLoading = false;
                });
        } else {
            Api.fetch('user/favorites', { product_id: id }, 'PUT')
                .then(response => {
                    if (response.success) {
                        const productIndex = this.regionOffers.findIndex(product => product.id === id);
                        this.regionOffers[productIndex] = { ...this.regionOffers[productIndex], isFavorite: true };
                    }
                })
                .finally(() => {
                    this.toggleLoading = false;
                });
        }
    };
}

decorate(DiscountStore, {
    loading: observable,
    toggleLoading: observable,
    discount: observable,
    userLevelInfo: observable,
    levels: observable,

    regionOfferLoading: observable,
    regionOffers: observable,

    getDiscounts: action,
    getOffers: action,
    getRegionOffers: action,
});
